import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  text: {
    id: 'LumaBot.LumaBotFlowSessionLog.LumaBotFlowSessionLogEmptyState.text',
    defaultMessage: 'No chat history was found for this session',
  },
});
